// var lazyLoadInstance = new LazyLoad();
document.addEventListener("DOMContentLoaded", function () {
	// mobileMenu();
	burgerMenu()
	anchorScroll();
	yoastFaq();
	responsiveTable();
	tabs();
	copyToBuffer();
	bindFancybox();
	addQueryParamsToLinks();
});

function burgerMenu() {
	const nav = document.getElementById('site-nav');
	if (!nav) return;

	const btnOpen = nav.querySelector('#btn-menu-open');
	const btnClose = nav.querySelector('#btn-menu-close');
	const menu = nav.querySelector('#site-nav-box');

	// menu.classList.add('loaded');

	btnOpen.addEventListener('click', (e) => menu.classList.add('open', 'loaded'))
	btnClose.addEventListener('click', (e) => menu.classList.remove('open', 'loaded'))
}


/**
 * Toggle main menu on mobile.
 */
function mobileMenu() {
	let el = document.querySelectorAll(".menu-toggle");
	for (var i = 0; i < el.length; i++) {
		el[i].addEventListener("click", function () {
			document.body.classList.toggle("menu-active");
			mobileSubMenu();
		});
	}
}

function mobileSubMenu() {
	let sub_menu_wrap = document.querySelectorAll(
		"#primary-menu .menu-item-has-children"
	);
	if (!sub_menu_wrap) {
		return;
	}
	sub_menu_wrap.forEach((item) => {
		item
			.querySelector(":scope > a")
			.addEventListener("click", function (event) {
				event.preventDefault();
				item.querySelector(".sub-menu").classList.toggle("show");
			});
	});
}

/**
 * Custom anchor scroll.
 * @returns void
 */
function anchorScroll() {
	let anchors = document.querySelectorAll(".anchor");
	if (!anchors) return;
	let headerOffset = 130;

	anchors.forEach((anchor) => {
		anchor.addEventListener("click", function (event) {
			event.preventDefault();
			let link = this.dataset.anchor,
				block = document.querySelector('[data-id="' + link + '"]');

			elementPosition = block.getBoundingClientRect().top;
			offsetPosition = elementPosition + window.pageYOffset - headerOffset;
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
		});
	});
}

/**
 * FAQ logic for yoast block
 */

function yoastFaq() {
	let blocks = document.querySelectorAll(".schema-faq-question");
	if (!blocks) {
		return;
	}

	blocks.forEach((block) => {
		block.addEventListener("click", function () {
			block.classList.toggle("active");
		});
	});
}

/**
 * Make default table responsive.
 */
function responsiveTable() {
	let blocks = document.querySelectorAll(".collapse-table");
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		let tableHeaders = block.querySelectorAll("table thead th");
		if (!tableHeaders.length) {
			block.classList.add("no-headers");
			return;
		}

		tableRows = block.querySelectorAll("table tbody tr");
		tableRows.forEach((row) => {
			let cells = row.querySelectorAll("td");
			cells.forEach((cell, index) => {
				text = tableHeaders[index].textContent;
				cell.dataset.label = text;
			});
		});
	});
}

/**
 * Tabs.
 */
function tabs() {
	let tabsBlocks = document.querySelectorAll(".has-tabs");

	if (!tabsBlocks.length) return;

	tabsBlocks.forEach((tabsBlock) => {
		let tabLinks = tabsBlock.querySelectorAll(".tab-nav button"),
			tabContents = tabsBlock.querySelectorAll(".tab-content");
		tabLinks.forEach((tabLink) => {
			tabLink.addEventListener("click", function (event) {
				event.preventDefault();
				if (tabLink.classList.contains("active")) return;
				let tabTarget = tabLink.dataset.target;
				currTabLink = [...tabLinks]
					.filter((element) => element.classList.contains("active"))[0]
					.classList.remove("active");
				currTabContent = [...tabContents]
					.filter((element) => element.classList.contains("active"))[0]
					.classList.remove("active");

				this.classList.add("active");
				tabsBlock.querySelector("#" + tabTarget).classList.add("active");
			});
		});
	});
}

/**
 * Copy to buffer.
 */
function copyToBuffer() {
	let btns = document.querySelectorAll(".copy-to-buffer");
	if (btns.length) {
		btns.forEach((btn) => {
			btn.addEventListener("click", function () {
				btn.classList.add("copied");
				// Create a temporary text area element
				var tempTextArea = document.createElement("textarea");

				// Set its value to the input field's value
				tempTextArea.value = btn.dataset.copy;

				// Append it to the document (not visible to the user)
				document.body.appendChild(tempTextArea);

				// Select the text inside the temporary text area
				tempTextArea.select();

				// Execute the copy command
				document.execCommand("copy");

				// Remove the temporary text area from the document
				document.body.removeChild(tempTextArea);

				let tooltips = btn.querySelectorAll(".svg-tooltip");
				if (tooltips.length) {
					tooltips.forEach((tooltip) => {
						tooltip.textContent = "Copied!";
						setTimeout(function () {
							tooltip.textContent = "Copy promo code";
						}, 2000);
					});
				}

				setTimeout(function () {
					btn.classList.remove("copied");
				}, 2000);
			});
		});
	}
}

function putImageOnPage(imgTagString = "", id = "") {
	let referenceElement = document.getElementById(id);

	if (referenceElement) {
		referenceElement.insertAdjacentHTML("afterend", imgTagString);
	}
}

// Fancybox content init.
function bindFancybox() {
	if (!window.Fancybox) return;

	Fancybox.bind('[data-fancybox]', {
		type: "inline",
	});
}

/**
 * Add URL query parameters to the link.
 * @returns {void} Return updated links with query parameters from page URL.
 */
function addQueryParamsToLinks() {
	const currentHostname = window.location.hostname;
	const baseUrl = window.location.origin;
	const urlParams = new URLSearchParams(window.location.search);
	const links = document.querySelectorAll('a');

	links.forEach(link => {
		try {
			const linkUrl = new URL(link.href, baseUrl);

			if (linkUrl.pathname.contains('wp-admin')) {
				return;
			}

			if (linkUrl.hostname === currentHostname) {
				urlParams.forEach((value, key) => {
					if (!linkUrl.searchParams.has(key)) {
						linkUrl.searchParams.append(key, value);
					}
				});

				// Update the href of the link.
				link.href = linkUrl.toString();
			}
		} catch (e) {
			// Ignore links with invalid URLs.
			console.warn(`Invalid URL skipped: ${link.href}`);
		}

	})
}

